import { useState } from "react";

import { AwardItemDesktop } from "./AwardItemDesktop";

function AwardDesktop() {
  const [hoveredIndex, setHoveredIndex] = useState<number>();

  return (
    <section id="awards" className="pt-[40px] mb-[40px]">
      <div className="container items-start flex flex-col">
        <div className="flex flex-row items-center">
          <p className="text-[24px] font-medium mb-8">Competitions</p>
        </div>

        <AwardItemDesktop
          time="Oct 2024"
          title="Third prize in AI Challenge Ho Chi Minh City - Event Retrieval
              from Visual Data (Top 5/800)"
          description="Our team of 5 built a system to search for specific event frames within 1,400-video dataset"
          hoverId={1}
          hoveredIndex={hoveredIndex}
          setHoveredIndex={setHoveredIndex}
        />

        <AwardItemDesktop
          time="May 2024"
          title="Top 15 CodeRace 2024 Autonomous Driving - Bosch Global Vietnam"
          description="Solved Adaptive Cruise Control problems for highway driving"
          hoverId={2}
          hoveredIndex={hoveredIndex}
          setHoveredIndex={setHoveredIndex}
        />

        <AwardItemDesktop
          time="Nov 2022"
          title="Ranked 6th out of 75 Teams - 2022 UIT-VNU Hackathon"
          description="Led a team of 4 to design and develop an environmental
              protection software application within 24 hours"
          isLastItem
          hoverId={3}
          hoveredIndex={hoveredIndex}
          setHoveredIndex={setHoveredIndex}
        />
      </div>
    </section>
  );
}

export default AwardDesktop;
